<template>
	<v-dialog v-model="dialogPlayer" max-width="1000px" persistent>
		<v-card>
			<v-card-title>
				<span class="headline">{{ aula.nome }}</span>
        <v-spacer></v-spacer>
				<v-btn color="brown darken-1" icon @click="close()" title="Fechar">
					<v-icon>fal fa-times</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-subtitle>
				<span v-for="src in source" :key="src.resolucao">{{ src.file }}</span>
			</v-card-subtitle>
			<v-progress-linear
				indeterminate
				color="cyan"
				v-if="!showPlayer"
				class="my-4"
			></v-progress-linear>
			<div class="player-container" v-if="showPlayer">
				<vue-plyr>
					<video>
						<source v-for="src in source" :key="src.resolucao" :src="src.src" :type="getVideoType(src.file)" :size="src.resolucao">
					</video>
				</vue-plyr>
			</div>
    </v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
		aula: {
			id: 0,
			nome: 'Aula'
		}
	},
	data() {
		return {
			server: 'video',
			showPlayer: false,
			source: [],
		}
  },
  computed: {
		...mapState(['user', 'dialogPlayer'])
	},
	created() {
		this.getData()
	},
	methods: {
		getVideoType(file){
			let array = file.split('.')
			let type = array[array.length-1]
			return 'video/'+type
		},
    close() {
			this.showPlayer = false
			this.$store.dispatch('dialogPlayer', { value: false })
		},
		getData() {
			let formData = new FormData()
			formData.append('menu', this.server)
			formData.append('function', 'get_src_' + this.server)
			formData.append('user_id', this.user.id)
			formData.append('aula_id', this.aula.id)
			let vd = this
			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					if (response.data.error === 0) {
						vd.source = response.data.videos
						setTimeout(() => {
							vd.showPlayer = true
						}, 1000)
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destino: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERRO!! ' + response)
				})
		},

	},
}
</script>